import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import styled from 'styled-components';
import { fluidRange } from 'polished';
import Button from '../../base/button';

const subscribe = ({ content, link }) => {
    if (Array.isArray(content) && content.length > 0) {
        return (
            <SIntro>
                <SText>{RichText.render(content)}</SText>

                {link && (
                    <SButtonWrapper>
                        <Button to={link.url} external={true}>
                            Inschrijven
                        </Button>
                    </SButtonWrapper>
                )}
            </SIntro>
        );
    } else {
        return false;
    }
};

const SIntro = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
`;

const SButtonWrapper = styled.div`
    width: 100%;
    max-width: 760px;

`

const SText = styled.div`
    ${fluidRange(
        {
            prop: 'font-size',
            fromSize: '15px',
            toSize: '18px'
        },
        '320px',
        '1440px'
    )}
    line-height: 1.5;
    color: var(--color-gray-darker);
    max-width: 760px;
    margin-bottom: 20px;

    a {
        text-decoration: underline;
    }
`;

export default subscribe;

subscribe.propTypes = {
    content: PropTypes.array,
    link: PropTypes.object
};
